export const ModalFormLayout = {
  MODAL: 'modal',
  EMBEDDED: 'embedded',
};

export const LAYOUT_CLASS_NAME_MAP = {
  [ModalFormLayout.MODAL]: 'flex flex-col items-stretch p-24 w-full gap-24',
  [ModalFormLayout.EMBEDDED]: 'flex flex-col gap-48 flex-1 w-full',
};
